import { memo } from 'react';
import { Stack, Box, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useAppDispatch } from 'store';
import { closeDialog } from 'store/dialog/dialogSlice';

interface IDialogTitleProps {
  hideCloseButton?: boolean;
  children?: React.ReactNode;
  marginBottom?: string;
  onClose?: () => void;
}

function DialogTitle({ hideCloseButton, marginBottom, children, onClose }: IDialogTitleProps) {
  const dispatch = useAppDispatch();

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    dispatch(closeDialog());
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ height: 29, marginBottom: marginBottom || '24px' }}
    >
      <Stack direction="row" alignItems="center" spacing="8px">
        <Typography sx={{ fontSize: 20, fontWeight: 700 }}>{children}</Typography>
      </Stack>
      {!hideCloseButton && (
        <Box
          sx={theme => ({
            color: theme.palette.mind.grey.brown,
            ':hover': { color: theme.palette.mind.grey.brown, cursor: 'pointer' },
          })}
          onClick={handleClose}
        >
          <Close />
        </Box>
      )}
    </Stack>
  );
}

export default memo(DialogTitle);
